"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDecidedIn = loadDecidedIn;
const app_1 = require("@kalkulacka-one/app");
// In a later round, a district whose seat was already won is marked with the round it was decided in.
async function loadDecidedIn({ endpoint, group, keys, election, now }) {
    if (!election.rounds)
        return {};
    const current = (0, app_1.currentRound)(election.rounds, now).current;
    if (current <= 1)
        return {};
    const entries = await Promise.all(keys.map(async (key) => {
        try {
            const candidates = await (0, app_1.loadCandidates)({ endpoint, key, group });
            const elected = candidates.filter((candidate) => candidate.elected);
            const decidedIn = elected.reduce((round, candidate) => Math.max(round ?? 0, ...(candidate.rounds ?? [current - 1])), undefined);
            return decidedIn === undefined ? undefined : [key, decidedIn];
        }
        catch (error) {
            if (!(error instanceof app_1.NotFoundError))
                console.error(`Candidates of \`${group}/${key}\` could not be loaded`, error);
            return undefined;
        }
    }));
    return Object.fromEntries(entries.filter((entry) => entry !== undefined));
}
